import lazyLoading from './lazyLoading'

export default {
  name: 'HomeNet Parking',
  path: '/homenet/parking',
  redirect: '/homenet/parking/info',
  meta: {
    auth: ['user'],
    icon: 'fas fa-cube',
    expanded: false
  },
  component: lazyLoading('homenet', true),
  children: [
    {
      'name': 'Parking Info',
      'path': 'info',
      'meta': {
        'label': 'Parking Info'
      },
      'component': lazyLoading('homenet/ParkingInfo')
    },
    {
      'name': 'Parking Management',
      'path': 'admin',
      'meta': {
        'label': 'Parking Management'
      },
      'component': lazyLoading('homenet/ParkingAdmin')
    }
  ]
}



// WEBPACK FOOTER //
// ./client/store/modules/menu/parking.js